
const panelArrays_reducer = (state = [] , action) => {
	let currentArray = -1
	var i;
	if(typeof state.currentArray !== "undefined" && state.currentArray >0 && !isNaN(state.currentArray))
		currentArray = state.currentArray

	switch(action.type) {

		case 'ADDOPTIMISERS':	// Add our Optimiser Types in 
			return {...state,optimisers: [...action.payload]}
		case 'ADDPANELS':	// Add our Optimiser Types in 
			return {...state, panels: [...action.payload]}
		case 'INITPANELS':
			return{...state,panelArrays: [...action.payload]}
		case 'SETSELECTEDPANEL':	// Set the Selected Panel
			if(isNaN(action.payload))
				return state
			return {...state,
				currentArray: action.paylaod
			}
		case 'SETDONTUPDATEALLPANELS':	// Set if Update All Panels
			return {...state,
				dontupdateAll: action.payload}
		case 'ADDTOARRAY':			// Add to the Arrays

			if(typeof state.panels == "undefined") {
				return state
			}
			var panel
			
			let panelCopy = []
			let newarr = false
			i = 0;

			if(typeof state.panelArrays !== "undefined") {
				panelCopy = [...state.panelArrays]
				i = panelCopy.length
				panel = panelCopy[i-1];
			}else{
				newarr = true
				panel = state.panels[8]
			}
	
			if(typeof panel == "undefined") {
				return state
			}
			for(; i<action.payload; i++) {
				panelCopy.push( {
						key: i,
						arrayNumber: i+1,
						numPanels: 8,
						panel_id: panel.panel_id,
						panelType: newarr ? panel.description + ' - ' + panel.type : panel.panelType,
						watts: panel.watts,
						panelModel: '',
						roofPitch: 35,
						orientation: 0,
						shading: 0.9,
						description: `Array ${i+1} Description`,
						moneysaving: 0.00,
						kwphsavings: 0.00,
						birdprotection: false,
						unit_cost: panel.unit_cost,
						customer_price: panel.customer_price,
						unit_qty: panel.unit_qty,
						installation_location: {},
						calcData: {},
						layoutSets: [],  // Initialize empty layout sets for rails/hooks calculation
						railColour: 'silver', // Default (Black supply has long lead times); per-array override via Rail Colour radio
						width_mm: panel.width_mm || 1134,   // Panel width in mm
						height_mm: panel.height_mm || 1722  // Panel height in mm

					})	
				}
				return {...state,
				panelArrays: [...panelCopy]
			};

		case 'REMOVEFROMARRAY':	// Remove from the Array
			const arrtoremove = [...state.panelArrays]

			const filterPanels = arrtoremove.filter(array => array.key != action.payload)
			return {...state,
				panelArrays: filterPanels
			};
		case 'UPDATEPANELARRAY':
			let newArray = [...state.panelArrays]
			for(i =0; i<newArray.length; i++) {
				if(state.dontupdateAll ) {
					if(currentArray < 0)
						return state;

					if(i == currentArray ) {
						newArray[i].panelType = action.payload.description + ' - ' + action.payload.type;
						newArray[i].watts = action.payload.watts;
						newArray[i].panel_id= action.payload.panel_id;
						newArray[i].panelModel = action.payload.description;
						newArray[i].unit_cost = action.payload.unit_cost;
						newArray[i].customer_price = action.payload.customer_price;
						newArray[i].unit_qty = action.payload.unit_qty;
						newArray[i].width_mm = action.payload.width_mm || 1134;
						newArray[i].height_mm = action.payload.height_mm || 1722;
					}
				}else {
					newArray[i].panelType = action.payload.description + ' - ' + action.payload.type;
					newArray[i].watts = action.payload.watts;
					newArray[i].panel_id = action.payload.panel_id;
					newArray[i].panelModel = action.payload.description;
					newArray[i].unit_cost = action.payload.unit_cost;
					newArray[i].customer_price = action.payload.customer_price;
					newArray[i].unit_qty = action.payload.unit_qty;
					newArray[i].width_mm = action.payload.width_mm || 1134;
					newArray[i].height_mm = action.payload.height_mm || 1722;
				}
			}
			newArray[currentArray].birdprotection = state.panelArrays[currentArray].birdprotection;
			newArray[currentArray].installation_location = state.panelArrays[currentArray].installation_location
			return {
				...state,
				panelArrays: newArray
			}
		case 'UPDATENUMPANELS':
			if(currentArray < 0)
				return state;
			let newNum = [...state.panelArrays]
			newNum[currentArray].numPanels = action.payload
			// Check if we need to update the number of Optimisers (Solar Edge QTY needs one per panel)
			if(typeof newNum[currentArray].optimiser !=="undefined" && newNum[currentArray].optimiser.type === "SE") 
            	newNum[currentArray].qty_optimisers = action.payload
			// Non Solar Edge we dont want more Optimsers than panels	
			else if( typeof newNum[currentArray].optimiser !=="undefined" && newNum[currentArray].optimiser.type !== "SE" && newNum[currentArray].qty_optimisers > action.payload)
				newNum[currentArray].qty_optimisers = action.payload
			return { ...state,
					panelArrays: newNum}
		case 'UPDATEPANELDESCRIPTION':
			if(currentArray < 0)
				return state;
			let newDesc = [...state.panelArrays]
			newDesc[currentArray].description = action.payload
			return {...state,panelArrays: newDesc}
		case 'UPDATEPANELORIENTATION' :
			if(currentArray < 0)
				return state;
			let d = action.payload
			if( d>175) d = 175
			if( d<0) d = 0;
			let panOrien = [...state.panelArrays]
			panOrien[currentArray].orientation = d
			return {...state,panelArrays:panOrien}

		case 'UPDATEPANELROOFPITCH':
			if(currentArray < 0)
				return state;
			let rp = action.payload
			if( rp>90) rp = 90
			if( rp<0) rp = 0;
			let panRP = [...state.panelArrays]
			panRP[currentArray].roofPitch = rp
			return {...state,panelArrays:panRP}	
		case 'UPDATEPANELSHADING':
			if(currentArray < 0)
				return state;
			let ps = action.payload
			if( ps>1) ps = 1
			if( ps<0) ps = 0;
			let panShading = [...state.panelArrays]
			panShading[currentArray].shading = ps
			return {...state,panelArrays:panShading}	
		case 'UPDATEBIRDPROTECTION':
			if(currentArray < 0)
				return state;
			let panBirdProt = [...state.panelArrays]
			panBirdProt[currentArray].birdprotection = ps
			return {...state,panelArrays:panBirdProt}	
		case 'UPDATEPANELINSTALLATIONLOCATION':
			if(currentArray < 0)
				return state;
			let panInstLoc = [...state.panelArrays]
			panInstLoc[currentArray].installation_location = ps
			return {...state,panelArrays:panInstLoc}
		case 'UPDATEOPTIMISERS':
			let optArray = [...state.panelAttays]
			const selOptimiser = action.payload	
			if(selOptimiser&& typeof selOptimiser !== "undefined") {
				if(selOptimiser.type === "SE") {
					for(i=0; i<newArray.length; i++){
						optArray[i].qty_optimisers = parseInt(optArray[i].numPanels)
						optArray[i].optimiser = {...selOptimiser}
					}
				}else {
					for(var i=0; i<optArray.length; i++){
						if(typeof optArray[i].optimiser.type !== "undefined") 
							if( optArray[i].optimiser.type == 'SE')
								optArray[i].optimiser = state.optimisers[0]       // FIrst is always None
					}
					if(currentArray >=0) {
						optArray[currentArray].qty_optimisers  = parseInt(optArray[currentArray].numPanels)
						optArray[currentArray].optimiser = {...selOptimiser}
					}
				}
			}
			return {...state,panelArrays: optArray}

		case 'UPDATE_LAYOUT_SETS':
			// Update layout sets for a specific array
			const { arrayIndex, layoutSets } = action.payload
			if (arrayIndex < 0 || !state.panelArrays || arrayIndex >= state.panelArrays.length)
				return state
			let panelLayoutSets = [...state.panelArrays]
			panelLayoutSets[arrayIndex] = {
				...panelLayoutSets[arrayIndex],
				layoutSets: layoutSets
			}
			return { ...state, panelArrays: panelLayoutSets }

		default:
			return state;

	}
}

export default panelArrays_reducer;
